import { useMemo } from 'react'

import { type LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'
import { useQueryLegalEntities } from '../useQueryLegalEntities'

interface UseQueryActiveLegalEntitiesOptions {
  enabled?: boolean
}

interface UseQueryActiveLegalEntitiesReturn {
  entities: LegalEntity[]
  isFetching: boolean
  isLoading: boolean
  isError: boolean
}

/**
 * Returns only the Active Legal Entities, for the Multi-Entity selector surfaces.
 *
 * Selects off `useQueryLegalEntities` so React Query dedupes and the active
 * subset stays consistent with the full list. The `?active=true` server-side
 * filter is a future path if the set outgrows the client.
 */
export const useQueryActiveLegalEntities = (
  options: UseQueryActiveLegalEntitiesOptions = {}
): UseQueryActiveLegalEntitiesReturn => {
  const {
    entities: allEntities,
    isFetching,
    isLoading,
    isError,
  } = useQueryLegalEntities({ enabled: options.enabled })

  const entities = useMemo(
    () => allEntities.filter((entity) => entity.active),
    [allEntities]
  )

  return {
    entities,
    isFetching,
    isLoading,
    isError,
  }
}
